<template>
  <div class="modal-tom">
    <div class="modal-content d-flex flex-column align-items-center ">
      <div class="d-flex flex-column align-items-center position-relative w-100" v-if="!showPasswordResetForm">
        <div class="d-flex justify-content-between w-100 modal-header">
          <div></div>
          <h4 class="fw-bold fs-3 ">Password Reset</h4>
          <button class="btn btn-gray btn-xl" @click="toggleCodePopup">
            <i class="fa fa-close"></i>
          </button>
        </div>
        <div class="d-flex flex-column p-5">
          <p class="fs-5">Enter your email and we'll send you a password reset code.</p>
          <input type="text" placeholder="Email" class="form-control form-control-lg mb-2" v-model="email" />
          <span class="error fs-6" v-if="error">{{ error }}</span>
          <div class="d-flex justify-content-center mt-3" style="gap: 10px;">
            <loading-button style="height: 51.33px" v-if="loading"></loading-button>
            <button v-else class="btn btn-xl btn-primary" @click="requestAccessCode">
              Submit
            </button>
            <button class="btn btn-xl btn-secondary" @click="toggleResetFormManual">
              I have a reset code
            </button>
          </div>
        </div>
        
      </div>



      <div class="d-flex flex-column align-items-center w-100 position-relative" v-else-if="showPasswordResetForm && !success">
        <div class="d-flex justify-content-between w-100 modal-header"> 
          <div></div>
          <h4 class="fw-bold fs-3 ">{{ isSetPasswordMode ? 'Set Password' : 'Reset Code' }}</h4>
          <button class="btn btn-gray btn-xl" style="font-size: 24px;" @click="toggleCodePopup">
            <i class="fa fa-close"></i>
          </button>
        </div>
        <div class="d-flex flex-column align-items-center w-100 p-5" >

          <p class="fs-5" v-if="!isSetPasswordMode">
            Check your email for a reset code, and enter it below.
          </p>

          <div class="w-100 mb-3" v-if="isSetPasswordMode">
            <p class="fw-bold mb-1">Your password must:</p>
            <ul class="mb-0 ps-4">
              <li>Be between 8 and 20 characters</li>
              <li>Include at least one uppercase letter</li>
              <li>Include at least one lowercase letter</li>
              <li>Include at least one number</li>
              <li>Include at least one special character (e.g. ! ? @ #)</li>
            </ul>
          </div>

          <div class="w-100 d-flex flex-column">
            <input autocomplete="new-email" id="email" v-if="showEmailForm" type="text" placeholder="Email" class="form-control form-control-lg mb-2" v-model="email" />
            <input autocomplete="new-password" id="code" v-if="!isSetPasswordMode" class="form-control form-control-lg mb-2" type="text" v-model="code" placeholder="Reset Code" />
            <input autocomplete="new-password" id="password" class="form-control form-control-lg mb-2" type="password" v-model="newPassword" placeholder="Enter New Password" />
            <input autocomplete="new-password" id="passwordConfirm" class="form-control form-control-lg mb-2" type="password" v-model="newPasswordConfirm" placeholder="Confirm New Password" />
          </div>
          <span class="error fs-6" v-if="invalidCode">Invalid Code</span>
          <span class="error fs-6" v-if="!passwordMatch">Passwords don't match</span>
          <span class="error fs-6" v-if="error?.length">{{ error }}</span>
          <div class="d-flex justify-content-center mt-3 w-100" style="gap: 10px;">
            <button class="btn btn-xl btn-primary" v-if="!loading" @click="resetPassword">
              Submit
            </button>
            <loading-button style="height: 51.3px" v-if="loading" class="btn btn-xl btn-primary"></loading-button>
            <button class="btn btn-xl btn-secondary" @click="toggleCodePopup">Cancel</button>
          </div>
        </div>
      </div>



      <div v-else class="d-flex flex-column align-items-center">
        <div class="d-flex justify-content-center modal-header w-100">
          <h4 class="fs-3 fw-bold">Success!</h4>
        </div>
        <div class="d-flex flex-column p-5">
          <p class="fs-5">Your password has been reset. Enter your email and new password to sign in.</p>
          <div>
            <button class="btn btn-primary btn-xl" @click="toggleCodePopup">Close</button></div>
        </div>
        
      </div>
      <!-- <div ></div> -->
    </div>
  </div>

</template>
<script>
import LoadingButton from "../../components/utils/LoadingButton.vue";
import axios from "axios";
import VueRecaptcha from "vue-recaptcha-v3";
export default {
  name: "ResetPassword",
  components: { LoadingButton, VueRecaptcha },
  props: {
    // When opened from an emailed set-password link, prefill email + code and
    // jump straight to the reset form (skip requesting a code).
    prefillEmail: { type: String, default: "" },
    prefillCode: { type: String, default: "" },
  },
  data() {
    return {
      email: this.prefillEmail || "",
      // JWTUserId: '',
      // JWTUserResetCodesId: '',
      showPasswordResetForm: false,
      code: this.prefillCode || "",
      newPassword: "",
      newPasswordConfirm: "",
      loading: false,
      passwordMatch: true,
      success: false,
      invalidCode: false,
      error: null,
      showEmailForm: false,
      passwordStrength: true,
    };
  },
  computed: {
    // True only for the student invite flow, where the reset code is prefilled from
    // the URL. Used to switch this modal to a "Set Password" view; all other callers
    // (no prefillCode) keep the normal Reset Code display unchanged.
    isSetPasswordMode() {
      return !!this.prefillCode;
    },
  },
  methods: {
    toggleCodePopup() {
      // console.log("BING");
      this.$emit("togglePasswordResetModal");
    },
    toggleResetFormManual() {
      this.showEmailForm = true;
      this.showPasswordResetForm = true;
    },
    async requestAccessCode() {
      this.$recaptcha("login").then(async (captchaToken) => {
        // console.log("CAPTCHA TOKEN", captchaToken);
        this.loading = true;
        if (!this.email) {
          this.error = 'Please enter an email address.'
          this.loading = false;
          return;
        }
        const bodyObject = {
          UserName: this.email,
        };
        const foundUser = await axios
          .post(process.env.VUE_APP_ENDPOINT + "/api/auth/requestResetCode", bodyObject)
          .then((result) => {
            if (result?.data?.Error?.length > 0) {
              this.error = result.data?.Error;
              this.loading = false;
            } else {
              // console.log(result.data);
              // this.JWTUserId = result.data.userId;
              // this.JWTUserResetCodesId = result.data.JWTUserCodesId
              this.loading = false;
              this.showPasswordResetForm = true;
            }
          }).catch(e => {
            console.log(e)
            this.error = e.Error;
            console.log(this.error)
            this.loading = false;

          });
      });
    },
    async resetPassword() {
      this.passwordMatch = true;
      this.passwordStrength = true;
      // console.log(this.newPassword);
      this.comparePasswords();
      if (this.passwordMatch && this.passwordStrength && this.newPassword === this.newPasswordConfirm) {
        this.loading = true;
        const bodyObject = {
          password: this.newPassword,
          code: this.code,
          email: this.email,
        };
        
        const request = axios
          .post(process.env.VUE_APP_ENDPOINT + "/api/auth/resetPassword", bodyObject)
          .then((result) => {

            this.success = true;
            this.loading = false;
          })
          .catch((error) => {
            if (error) {
              this.invalidCode = true;
              this.loading = false;
            }
          });
      }
    },
    comparePasswords() {
      // console.log(this.newPassword);
      // console.log("PASSWORD CHECK1");
      if (this.newPassword !== this.newPasswordConfirm) {
        // console.log("WRONG");
        this.passwordMatch = false;
      } else if (
        this.newPassword.length < 8 ||
        this.newPassword.length > 20 ||
        !this.newPassword.match(/[a-z]/) ||
        !this.newPassword.match(/[A-Z]/) ||
        !this.newPassword.match(/[0-9]/) ||
        !this.newPassword.match(/[^a-zA-Z\d]/)
      ) {
        this.passwordStrength = false;
        this.error = 'Password must be between 8 and 20 characters and contain at least one lowercase letter, one uppercase letter, one number, and one special character.'
      } else {
        this.passwordMatch = true;
      }
    },
  },
  watch: {
    passwordConfirm: "comparePasswords",
  },
  created() {
    // Arrived via an emailed set-password link: skip the request-code step.
    if (this.prefillCode) {
      this.showPasswordResetForm = true;
      this.showEmailForm = false;
    }
  },
};
</script>
<style scoped>
.error {
  font-size: 8px;
  color: red;
}
</style>
